import Image from 'next/image';
import Link from 'next/link';

import { PATHS } from '@/constants/paths';

const Footer = () => {
  return (
    <footer className="bg-black px-5 py-6 text-white">
      <div className="mx-auto max-w-[393px]">
        {/* 主要リンク */}
        <div className="mb-8 flex items-center justify-around">
          <div className="flex flex-col items-center">
            <div className="relative mb-2 flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-white">
              <Image src="/image/nomiss-icon.png" alt="Nomiss" fill className="object-cover" />
            </div>
            <span className="text-xs font-semibold">nomissについて</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="mb-2 flex h-12 w-12 items-center justify-center">
              <svg className="h-12 w-12 text-white" fill="none" viewBox="0 0 48 48">
                <path fill="currentColor" d="M6 14h36v2H6zm0 8h36v2H6zm0 8h36v2H6z" />
              </svg>
            </div>
            <span className="text-xs font-semibold">サービス一覧</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="mb-2 flex h-11 w-11 items-center justify-center">
              <svg className="h-11 w-11 text-white" fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="1.5"
                  d="M12 8v5m0 3v.01"
                />
              </svg>
            </div>
            <span className="text-xs font-semibold">ヘルプ</span>
          </div>
        </div>

        {/* 詳細リンク */}
        <div className="space-y-3 text-center text-[10px] font-medium">
          <div className="flex justify-center gap-8">
            <a
              href={PATHS.EXTERNAL.COMPANY}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              会社概要
            </a>
            <Link href={PATHS.TERMS} className="hover:text-gray-300">
              利用規約
            </Link>
            <Link href={PATHS.PRIVACY} className="hover:text-gray-300">
              プライバシーポリシー
            </Link>
          </div>
          <div className="flex justify-center gap-8">
            <span className="cursor-pointer hover:text-gray-300">Cookieポリシー</span>
            <a
              href={PATHS.EXTERNAL.TOKUSHOHO}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              特定商取引法に基づく通販の表記
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
